<template>
    <div>
        <NavbarOne />
        <MainBanner />
        <GetIntroduced />
        <Counter class="two-counter-area" />
        <WeHaveOffer />
        <Services />
        <CeoSection />
        <MaintenancePlan />
        <ContactStrip /> 
        <OurCoreService subTitle="SUMINISTRO PROFESIONAL DE TINTAS PARA IMPRESIÓN DIGITAL" heading="Tintas Originales y Compatibles" />

        
        <GetAddress />
        <OurTeam class="two-team-area" />
        <FunFact />
        <CoustomerFeedbacks />
        <FrequentlyQuestion />
        <Faq />
        <ContactWithUs />
        <Blog class="two-blog-area" />
        <Subscribe />
        <AmongThem subTitle="DESCARGAR NUESTRA APP" heading="¡Comercia desde cualquier parte del mundo!" />
        <Footer />
    </div>
</template>

<script>
import NavbarOne from '../Layouts/NavbarOne'
import MainBanner from '../HomePlotix/MainBanner'
import ContactStrip from '../HomePlotix/ContactStrip.vue';
import CeoSection from '../HomePlotix/CeoSection.vue'
import GetIntroduced from '../HomePlotix/GetIntroduced'
import Counter from '../Common/Counter'
import WeHaveOffer from '../HomePlotix/WeHaveOffer'
import MaintenancePlan from '../HomePlotix/MaintenancePlan'
import Services from '../HomePlotix/Services'
import OurCoreService from '../Common/OurCoreServiceTintas'
import GetAddress from '../HomePlotix/GetAddress'
import OurTeam from '../Common/OurTeam'
import FunFact from '../HomePlotix/FunFact'
import CoustomerFeedbacks from '../HomePlotix/CoustomerFeedbacks'
import FrequentlyQuestion from '../HomePlotix/FrequentlyQuestion'
import Faq from '../HomePlotix/Faq'
import ContactWithUs from '../HomePlotix/ContactWithUs'
import Blog from '../Common/Blog'
import Subscribe from '../HomePlotix/Subscribe'
import AmongThem from '../Common/AmongThem'
import Footer from '../Layouts/Footer'


export default {
    name: 'HomePagePlotix',
    components: {
        NavbarOne,
        MainBanner,
        //GetIntroduced,
        Counter, 
        WeHaveOffer,
        CeoSection,
        MaintenancePlan,
        ContactStrip,
        OurCoreService,
        Services,
        //OurCoreService,
        //GetAddress,
        //OurTeam,
        //FunFact,
        //CoustomerFeedbacks,
        //FrequentlyQuestion,
        //Faq,
        //ContactWithUs,
        //Blog,
        //Subscribe,
        //AmongThem,
        Footer, 
    }
}
</script>